import React, { useState } from "react";
import Button from "@amzn/meridian/button";
import Column from "@amzn/meridian/column";
import Icon from "@amzn/meridian/icon";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import editTokens from "@amzn/meridian-tokens/base/icon/edit";
import trashTokens from "@amzn/meridian-tokens/base/icon/trash";
import Box from "@amzn/meridian/box";
import { IDisplayFeaturesOrSpacesProps, propertyFeatures } from "./definitions";
import _ from "lodash";
import { getCurrencyFormat } from "../table/utils";
import { DeleteModal } from "./DeleteModal";
import { formatNumber } from "../../utils/formattingUtils";

export const DisplayFeaturesOnForm: React.FC<
    Omit<IDisplayFeaturesOrSpacesProps, "spaceDetails">
> = ({ featureDetails, sheetName, handleEditUpdateSheetAndOpen, handleDeleteItem }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState(null);

    const getFeatureDisplayInfo = currentFeature => {
        const feature = _.find(propertyFeatures, {
            value: currentFeature.featureType,
        });

        return currentFeature.featureType === "Other"
            ? {
                  name: currentFeature.featureName,
                  amount: getCurrencyFormat(currentFeature.quantity),
              }
            : {
                  name: currentFeature?.featureType,
                  amount: `${formatNumber(currentFeature.quantity)} ${feature?.quantityLabel || ""}`,
              };
    };

    return (
        <Row width={"fill"} wrap={"down"} widths={"fit"}>
            {featureDetails?.map(currentFeature => {
                return (
                    <Box type={"outline"} width={"fit"}>
                        <Row backgroundColor={"subdued"} width={"fit"} spacingInset={"400"}>
                            <Column width={"100%"}>
                                <Text type={"h200"}>
                                    {getFeatureDisplayInfo(currentFeature)?.name}
                                </Text>
                                <Text>{getFeatureDisplayInfo(currentFeature)?.amount} </Text>
                            </Column>
                            <Row>
                                <Button
                                    type="icon"
                                    onClick={() => {
                                        handleEditUpdateSheetAndOpen(sheetName, currentFeature.id);
                                    }}
                                >
                                    <Icon tokens={editTokens}>Settings</Icon>
                                </Button>

                                <Button
                                    type="icon"
                                    onClick={() => {
                                        setModalContent({
                                            id: currentFeature.id,
                                        });
                                        setIsModalOpen(true);
                                    }}
                                >
                                    <Icon tokens={trashTokens} />
                                </Button>
                            </Row>
                            {modalContent && (
                                <DeleteModal
                                    modalTitle={"Delete space"}
                                    modalDescription={
                                        "Are you sure you want to delete this feature?"
                                    }
                                    confirmHandler={() => handleDeleteItem(modalContent.id)}
                                    isModalOpen={isModalOpen}
                                    setIsModalOpen={setIsModalOpen}
                                />
                            )}
                        </Row>
                    </Box>
                );
            })}
        </Row>
    );
};
